<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid && isDescriptionValid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("supplies.sku_placeholder")' :danger="$v.form.sku.$invalid && $v.form.sku.$model" :danger-text="$t('validation.required', { attribute: $t('supplies.sku') })" v-model="form.sku" :label='$t("supplies.sku")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(v-on:keyup="searchDescription(form.description)" :placeholder='$t("supplies.description_placeholder")' :danger="$v.form.description.$invalid && $v.form.description.$model" :danger-text="$t('validation.required', { attribute: $t('supplies.description') })" v-model="form.description" :label='$t("supplies.description")')
          span.redText(v-if="!isDescriptionValid") {{ $t("supplies.description_exists_error") }}
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:placeholder='$t("supplies.tax_placeholder")' v-model="form.tax" :label='$t("supplies.tax")')
            vm-select-item(:key="index" :value="item.value" :text="item.name" v-for="(item,index) in tax")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("supplies.price_buy_placeholder")' :danger="$v.form.price_buy.$invalid && $v.form.price_buy.$model" :danger-text="$t('validation.required', { attribute: $t('supplies.price_buy') })" v-model="form.price_buy" :label='$t("supplies.price_buy")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("supplies.unit_of_measurement_placeholder")' :danger="$v.form.unit_of_measurement.$invalid && $v.form.unit_of_measurement.$model" :danger-text="$t('validation.required', { attribute: $t('supplies.unit_of_measurement') })" v-model="form.unit_of_measurement" :label='$t("supplies.unit_of_measurement")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("supplies.sat_code_placeholder")' :danger="$v.form.sat_code.$invalid && $v.form.sat_code.$model" :danger-text="$t('validation.required', { attribute: $t('supplies.sat_code') })" v-model="form.sat_code" :label='$t("supplies.sat_code")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Supplies')

export default {
  name: 'ModalSupplies',
  mixins: [ModalMixin1],
  data: () => ({
    tax: [
      {
        name: '0%',
        value: 0
      },
      {
        name: '8%',
        value: 8
      },
      {
        name: '16%',
        value: 16
      }
    ]
  }),
  validations () {
    return {
      form: {
        sku: {
          required
        },
        description: {
          required
        },
        tax: {
          required
        },
        price_buy: {
          required
        },
        unit_of_measurement: {
          required
        },
        sat_code: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'isDescriptionValid'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'searchDescription'
    ])
  }
}
</script>
<style lang="scss">
.redText {
  color: rgba(255,0,89,255)
}
</style>
